export default class DashboardCtrl {
    constructor(SideMenu) {
        SideMenu.setActive('dashboard');
    }
};